<template>
  <div
    v-editable="blok"
    class="QuoteBlock desktopMaxW-full"
    :class="[desktopWidth('md'), blockPaddingTop('md'), blockPaddingBottom('md')]"
  >
    <div
      class="layout-container flex desk:items-center flex-col desk:flex-row gap-32 desk:gap-64"
      :class="{
        'desk:flex-row-reverse': blok.leftAlignedContent,
      }"
    >
      <div
        v-if="blok.image && blok.image.filename"
        class="w-full desk:w-1/3"
        :class="{
          [blok.imageAspectRatio]: blok.imageAspectRatio,
        }"
      >
        <nuxt-img
          preset="standard"
          loading="lazy"
          sizes="sm:100vw desk:1260px"
          class="h-full w-full object-cover"
          :class="blok.focalPoint"
          :src="blok.image.filename"
          :alt="blok.image.alt"
        />
      </div>
      <div
        class="flex-1"
      >
        <div
          class="flex flex-col w-full gap-32"
          :class="{
            'text-left items-start': blok.textAlign === 'left',
            'text-center items-center': blok.textAlign === 'center',
          }"
        >
          <div
            class="type-headline-2xl"
          >
            {{ blok.quote }}
          </div>
          <div
            v-if="blok.author"
            class="leading-single text-text-subtle type-base"
          >
            {{ blok.author }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { DatasourceObjectPosition, StoryBlokAsset } from '#constants/types/storyblok';
import { AspectRatioKeys } from '#constants/AspectRatioKeys';
import useVisualAppearancePlugin from '~/composables/useVisualAppearancePlugin';

export interface QuoteBlockType {
  quote: string;
  author: string;
  image: StoryBlokAsset;
  focalPoint: DatasourceObjectPosition;
  imageAspectRatio: AspectRatioKeys;
  leftAlignedContent: boolean;
  textAlign : string;
}

const props = defineProps<{
  blok: QuoteBlockType,
}>();

const { desktopWidth, blockPaddingTop, blockPaddingBottom } = useVisualAppearancePlugin(props);
</script>
